<template>
  <div class="login">
    {{this.$store.state.xinhuaErrMsg}}
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'LoginView',
  data () {
    return {
      loginDisable: false
    }
  },
  computed: {
    ...mapState([
      'isLogin',
      'teacherAdmin',
      'userInfo',
      'loginFlag'
    ])
  },
  methods: {
    ...mapMutations([
      'setGradesMaxMin'
    ]),
    ...mapActions([
      'getXinhuaLogin',
      'getUserInfo',
      'getEndTime'
    ]),
    async xinhuaLogin() {
      if(this.$route.query.token){
        this.loginDisable = true
        try {
          let token = this.$route.query.token.replace(/ +/g,"+")
          await this.getXinhuaLogin({token: token}) // 登录
          if (this.isLogin && this.teacherAdmin.tokenValue) {
            sessionStorage.setItem('teacherAdmin', JSON.stringify(this.teacherAdmin))
            await this.getUserInfo() // 详细信息
            await this.getEndTime() // 到期续费
            if (this.userInfo) {
              if (this.userInfo.city === 5203001232323) {
                sessionStorage.clear();
                this.$message.warning('因系统升级，7月10日之前进入升级维护期')
              } else {
                this.$message.success('登录成功', 1)
                let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (userInfo.max_grade && userInfo.min_grade) { // 判断是否设置年级范围
                  let gradeList = [userInfo.min_grade, userInfo.max_grade]
                  this.setGradesMaxMin(gradeList)
                  sessionStorage.setItem('gradeMaxMin', JSON.stringify(gradeList))
                  this.$router.push('/deskView')
                } else{
                  this.$router.push('/initView')
                }
              }
            } else {
              this.$message.error('此账号没有权限~')
            }
          } else if (this.isLogin && !this.teacherAdmin.tokenValue) {
            this.loginDisable = false
            this.$message.error('登录失败')
          } else {
            this.loginDisable = false
            // this.$message.error('请核对您输入的信息~')
            // this.$message.error('token过期，登陆失败')
          }
        } catch (e) {
          console.log(e)
          this.loginDisable = false
          this.$message.error('当前您的网络情况不佳，请刷新或稍后再试~')
        }
      }else{
        this.$message.error('未传递token，请手动登录~')
      }
    }
  },
  async mounted(){
    this.xinhuaLogin()
  }
}
</script>

<style>
.login{
  text-align: center;
  margin-top: 40px;
  font-size: 20px;
}
</style>
